<template>
  <div class="free-trial" :style="{ width: `calc(100% - ${menuWidth}px)` }">
    <v-icon class="free-trial-icon" color="primary">
      {{ icons.mdiRocketLaunchOutline }}
    </v-icon>
    <span v-html="$t('free_trial.text', { dayLeft: dayLeft, daysString: daysString })"></span>
    <router-link class="free-trial-subscription" to="/settings?tab=billing_payments">
      &nbsp;{{ $t("free_trial.view_subscription") }}
    </router-link>
  </div>
</template>

<script>
  import { mdiRocketLaunchOutline } from "@mdi/js";
  import { ref } from "@vue/composition-api";
  import store from "@/store";
  import { differenceInDays } from "date-fns";
  export default {
    name: "FreeTrialDisclaimer",
    props: {
      menuWidth: {
        type: Number,
        default: 0,
      },
    },
    setup() {
      const trialEndsAt = store.getters["billing/getTrialEndsAt"];
      // Need +1 because differenceInDays (date-fns lib) returns 1 less than actual days
      const dayLeft = ref(differenceInDays(new Date(trialEndsAt), new Date()) + 1);
      const daysString = ref("days");

      if (dayLeft.value === 1) {
        daysString.value = "day";
      }

      return {
        icons: {
          mdiRocketLaunchOutline,
        },
        dayLeft,
        daysString,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions.scss";

  .free-trial {
    padding: 6px 0;
    right: 0;
    color: get-color("headline-element-bg-200-trial");
    background-color: get-color("primary-65-trial");
    display: flex;
    justify-content: center;
    align-items: center;
    @include text-caption();
    z-index: 99;
    position: fixed;
    width: 100%;
    transition-property: transform, visibility, width;
    transition-duration: 0.4s;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1), ease;
    will-change: box-shadow, transform;

    &-icon {
      margin-right: 6px;
      width: 16px;
      height: 16px;

      ::v-deep {
        svg {
          color: get-color("primary-menu-trial");
        }
      }
    }

    &-subscription {
      text-decoration: none;
      cursor: pointer;
      font-weight: 700;
      color: get-color("primary-menu-trial");
    }
  }
</style>
